import { Component } from '@angular/core';

import {
  SkyModalService,
  SkyModalCloseArgs
} from '../../core';

import { SkyFilterDemoModalComponent } from './filter-demo-modal.component';
import { SkyFilterDemoModalContext } from './filter-demo-modal-context';


export class SkyFilterDemoComponent {
  public appliedFilters: any[] = [];
  public items: any[] = [
    {
      name: 'Orange',
      description: 'A round, orange fruit.',
      type: 'citrus',
      color: 'orange'
    },
    {
      name: 'Mango',
      description: 'Delicious in smoothies, but don\'t eat the skin.',
      type: 'other',
      color: 'orange'
    },
    {
      name: 'Lime',
      description: 'A sour, green fruit used in many drinks.',
      type: 'citrus',
      color: 'green'
    },
    {
      name: 'Strawberry',
      description: 'A red fruit that goes well with shortcake.',
      type: 'berry',
      color: 'red'
    },
    {
      name: 'Blueberry',
      description: 'A small, blue fruit often found in muffins.',
      type: 'berry',
      color: 'blue'
    }

  ];

  public filteredItems: any[];

  constructor(private modal: SkyModalService) {
    this.filteredItems = this.items.slice();
  }

  public filterButtonClicked() {
    let modalInstance = this.modal.open(
      SkyFilterDemoModalComponent,
      [{
        provide: SkyFilterDemoModalContext,
        useValue: {
          appliedFilters: this.appliedFilters
        }
      }]
    );

    modalInstance.closed.subscribe((result: SkyModalCloseArgs) => {
      if (result.reason === 'save') {
        this.appliedFilters = result.data.slice();
        this.filteredItems = this.filterItems(this.items, this.appliedFilters);
      }
    });
  }

  public onDismiss(index: number) {
    this.appliedFilters.splice(index, 1);
    this.filteredItems = this.filterItems(this.items, this.appliedFilters);
  }

  private orangeFilterFailed(filter: any, item: any) {
    return filter.name === 'hideOrange' && filter.value && item.color === 'orange';
  }

  private fruitTypeFilterFailed(filter: any, item: any) {
    return filter.name === 'fruitType' && filter.value !== 'any' && filter.value !== item.type;
  }

  private itemIsShown(filters: any[], item: any[]) {
    let passesFilter = true,
        j: number;

    for (j = 0; j < filters.length; j++) {
      if (this.orangeFilterFailed(filters[j], item)) {
        passesFilter = false;
      } else if (this.fruitTypeFilterFailed(filters[j], item)) {
        passesFilter = false;
      }
    }

    return passesFilter;
  }

  private filterItems(items: any[], filters: any[]) {
    let i: number,
      passesFilter: boolean,
      result: any[] = [];

    for (i = 0; i < items.length; i++) {
      passesFilter = this.itemIsShown(filters, items[i]);
      if (passesFilter) {
        result.push(items[i]);
      }
    }

    return result;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-filter-demo',
  template: `<div>
  <sky-toolbar>
    <sky-toolbar-section>
      <sky-toolbar-item>
        <sky-filter-button
          (filterButtonClick)="filterButtonClicked()">
        </sky-filter-button>
      </sky-toolbar-item>
    </sky-toolbar-section>
    <sky-toolbar-section *ngIf="appliedFilters && appliedFilters.length > 0">
      <sky-filter-summary>
        <sky-filter-summary-item
          *ngFor="let item of appliedFilters; let i = index"
          (dismiss)="onDismiss(i)"
          (itemClick)="filterButtonClicked()">
          {{item.label}}
        </sky-filter-summary-item>
      </sky-filter-summary>
    </sky-toolbar-section>
  </sky-toolbar>
  <sky-repeater expandMode="none">
    <sky-repeater-item *ngFor="let item of filteredItems">
      <sky-repeater-item-title>
        {{item.name}}
      </sky-repeater-item-title>
      <sky-repeater-item-content>
        <div>
          {{item.description}}
        </div>
      </sky-repeater-item-content>
    </sky-repeater-item>
  </sky-repeater>

</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyModalService, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
